import { render, staticRenderFns } from "./UserAvatarContent.vue?vue&type=template&id=51438efe&scoped=true"
import script from "./UserAvatarContent.vue?vue&type=script&lang=js"
export * from "./UserAvatarContent.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarContent.vue?vue&type=style&index=0&id=51438efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51438efe",
  null
  
)

export default component.exports